<template>
    <div class="container">
        <div v-if="oidcUser">
            Signed in as {{ oidcUser.email }}
            <button v-on:click="returnToCampaignList">Campaigns</button>
            <button v-on:click="signOutOidc">Sign out</button>
        </div>
        <div v-else>
            Please sign in.
            <button v-on:click="signIn">Sign In</button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'UserPanel',
    computed: {
        ...mapGetters(['oidcUser', 'oidcIsAuthenticated']),
        hasAccess: function() {
            return this.oidcIsAuthenticated || this.$route.meta.isPublic;
        },
    },
    methods: {
        ...mapActions(['signOutOidc', 'oidcSignInCallback']),
        signIn() {
            this.$router.push({ path: '/play' });
        },
        returnToCampaignList() {
            this.$router.push({ path: '/campaign-list' });
        },
    },
};
</script>

<style scoped>
.container {
    position: fixed;
    bottom: 100px;
    right: 5px;
    padding: 0.5em;
    background-color: #ddd;
    font: x-small Consolas, Monaco, monospace;
    color: black;
    border: 2px solid #345;
}
</style>
